import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import auth from "@/router/middlewares/auth";
import middlewarePipeline from "@/router/middlewarePipeline";
import admin from "@/router/middlewares/admin";
import loggedIn from "@/router/middlewares/loggedIn";
import Dashboard from "@/views/Dashboard";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [
        loggedIn
      ]
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/imprint',
    name: 'imprint',
    component: () => import('../views/Imprint.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/Privacy.vue')
  },
  {
    path: '/admin',
    component: Dashboard,
    name: 'admin.dashboard',
    redirect: '/admin/inbox',
    meta: {
      middleware: [
        auth,
        admin
      ]
    },
    children: [
      {
        path: '/admin/inbox',
        name: 'admin.inbox',
        component: () => import('../views/admin/Inbox.vue'),
        meta: {
          middleware: [
            auth,
            admin
          ]
        }
      },
      {
        path: '/admin/requests',
        name: 'admin.requests',
        component: () => import('../views/admin/Requests.vue'),
        meta: {
          middleware: [
            auth,
            admin
          ]
        }
      }
    ]
  },{
    path: '/user',
    component: Dashboard,
    name: 'user.dashboard',
    redirect: '/user/ticket',
    meta: {
      middleware: [
        auth
      ]
    },
    children: [
      {
        path: '/user/inbox',
        name: 'user.inbox',
        component: () => import('../views/user/Inbox.vue'),
        meta: {
          middleware: [
            auth
          ]
        }
      },
      {
        path: '/user/ticket',
        name: 'user.ticket',
        component: () => import('../views/Ticket'),
        meta: {
          middleware: [
            auth
          ]
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('setPageLoading', true).catch()
  if (!to.name.includes('main')) {
    store.dispatch('setRoute', true).catch()
  } else {
    store.dispatch('setRoute', false).catch()
  }
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

router.afterEach(() => {
  setTimeout(() => {
    store.dispatch('setPageLoading', false)
  }, 1500)
})

export default router
